export const primary = '#0b479d';
export const secondary = '#00A3E0';
export const primaryText = '#222';
export const secondaryText = '#747474';
export const inputBorder = '#ccc';
export const error = '#ad1723';
export const danger = 'red';
export const disabledForeground = '#5a5a5a';
export const disabledBackground = '#f5f5f5';
export const disabledButton = '#aaa';
export const readonlyField = '#f5f5f5';
export const inactive = '#c2c2c2';
